import { render, staticRenderFns } from "./CardFilter.vue?vue&type=template&id=f2c17694&scoped=true&"
import script from "./CardFilter.vue?vue&type=script&lang=js&"
export * from "./CardFilter.vue?vue&type=script&lang=js&"
import style0 from "./CardFilter.vue?vue&type=style&index=0&id=f2c17694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c17694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c17694')) {
      api.createRecord('f2c17694', component.options)
    } else {
      api.reload('f2c17694', component.options)
    }
    module.hot.accept("./CardFilter.vue?vue&type=template&id=f2c17694&scoped=true&", function () {
      api.rerender('f2c17694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/CardFilter.vue"
export default component.exports